import React, {useEffect, useState} from 'react';
import MainLayout from '../components/MainLayout';
import Server from '../components/Server';
import {useLocation, useNavigate } from 'react-router-dom';
import OrderReviewSidebar from '../components/OrderReviewSidebar';
import OrderDetails from '../components/OrderDetails';
import useCart from '../hooks/useCart';
import GuardedNavigationModal from '../components/modals/GuardedNavigationModal';
import useNavigationGuard from '../hooks/useNavigationGuard';
import MainLayoutWithoutFooter from '../components/MainLayoutWithoutFooter';
import useEditCartItem from '../hooks/useEditCartItem';
import EditModal from '../components/modals/EditModal';
import { getActiveServerId } from '../utils/staffSession';
import { isOfflineAndroid,getOfflineServers } from '../utils/androidOfflineCart';
import { toast } from 'react-toastify'; 


const OrderReview = () => {
    const navigate = useNavigate();
    const location = useLocation();
    console.log('========== ORDER REVIEW LOCATION ==========');
    console.log('location.pathname:', location.pathname);
    console.log('location.state:', location.state);
    console.log('localStorage orderType:', localStorage.getItem('orderType'));
    console.log('localStorage selectedTables:', localStorage.getItem('selectedTables'));


    const checkoutType = location.state?.checkout_type || null
    const editOrderId = location.state?.edit_order_id || null;

    const orderType = location.state?.orderType || localStorage.getItem('orderType');
    console.log('ORDER REVIEW resolved orderType:', orderType);
    // 0, "0" and "" all mean "no server was recorded" - 205,130 takeaway orders in the estate are
    // stored with server_id = 0 rather than NULL. Normalised once here because the two differ in
    // JS: 0 is falsy but "0" is truthy, and whether this arrives as an int or a string depends on
    // the connection's emulatePrepares setting, not on anything this screen controls.
    const orderServerId = Number(location.state?.order_server_id) > 0
        ? location.state.order_server_id
        : null;

    let selectedTables = {};
    try {
        selectedTables = location.state?.selectedTables || JSON.parse(localStorage.getItem('selectedTables') || '{}');
    } catch {
        selectedTables = {};
    }
    const existing_order_id = location.state?.existing_order_id || null;
    const selected_customer_id = location.state?.selected_customer_id || null;
    // location.state.selected_table_ids is never actually set by any navigate() call into this
    // page - TakeawayCart.js only ever passes `selectedTables`, which is shaped inconsistently
    // by the time it gets here (a flat [id] array from a single tap, a {tabId: [ids]} object from
    // multi-select) - so without this fallback, the backend's registerOrderBeforePayment() never
    // receives table ids and silently never creates the table_occupancy row for this order,
    // regardless of table type. Object.values().flat() happens to normalize both shapes to the
    // same flat id list either way.
    const selected_table_ids = location.state?.selected_table_ids
        || (Object.values(selectedTables).flat().length > 0
            ? Object.values(selectedTables).flat().join(',')
            : null);
    const initialServiceType = location.state?.service_type || null;
    // selectedTables' shape can't reliably say which zone this order belongs to (see above) -
    // tabId is passed alongside it by every entry point (useTableOrdering.js -> Takeaway.js ->
    // TakeawayCart.js) specifically to answer that, with the same localStorage fallback the rest
    // of this page's nav-state reads already use for a reload losing location.state.
    const tabId = location.state?.tabId || localStorage.getItem('selectedTabId') || null;
    const isPagerOrder = tabId === 'pager-tab';
    // A PIN-identified staff member is the server, so the picker is redundant for them. The
    // dine-in path already works this way (TakeawayCart::handleQuickSendToKitchen short-circuits
    // and never opens this screen); express/takeaway/delivery comes through here and did not.
    //
    // Still shown when an existing order carries its own server - reviewing someone else's order
    // should keep, and allow changing, the server it was taken by.
    const activeStaffServerId = getActiveServerId();
    const isAutoTaggedServer = !orderServerId && !!activeStaffServerId;
    const [selectedServerId, setSelectedServerId] = useState(() => orderServerId || activeStaffServerId || null);
    const [offlineServers, setOfflineServers] = useState([]);
    const [serversLoading, setServersLoading] = useState(false);

    const [refresh, setRefresh] = useState(false);
    const {
        cartItems,
        dealsItem,
        halfAndHalfItems,
        servers,
        handleUpdateQty,
        handleRemoveItem,
        netTotal,
        removeID
      } = useCart(refresh,editOrderId);
    const cartItemsExist = Array.isArray(cartItems) && cartItems.length > 0;
    const { showModal, confirmNavigation, cancelNavigation, guardedNavigate } = useNavigationGuard(orderType && cartItemsExist);
    const handleConfirm = () => {
        localStorage.removeItem('orderType');
        localStorage.removeItem('selectedTables');
        confirmNavigation();
      };
   
      useEffect(() => {
            let cancelled = false;

            const loadServers = async () => {
                if (!isOfflineAndroid()) {
                    return;
                }

                setServersLoading(true);

                try {
                    const response = await getOfflineServers();

                    if (cancelled) {
                        return;
                    }

                    if (!response?.success) {
                        toast.error(
                            response?.error || 'Failed to load offline servers.'
                        );
                        return;
                    }

                    const loadedServers = Array.isArray(response.data)
                        ? response.data
                        : [];

                    console.log(
                        '[OFFLINE_SERVERS] Loaded servers:',
                        loadedServers
                    );

                    setOfflineServers(loadedServers);

                    if (loadedServers.length === 0) {
                        toast.error('No servers available offline.');
                    }
                } catch (error) {
                    if (!cancelled) {
                        console.error(
                            '[OFFLINE_SERVERS] Failed to load servers:',
                            error
                        );

                        toast.error('Failed to load offline servers.');
                    }
                } finally {
                    if (!cancelled) {
                        setServersLoading(false);
                    }
                }
            };

            loadServers();

            return () => {
                cancelled = true;
            };
    }, []);

      useEffect(() => {
        if (orderServerId) {
          setSelectedServerId(orderServerId);
        }
      }, [orderServerId]);
      
    // useEffect(() => {
    //     const token = localStorage.getItem('accessToken');
    //     if (!token) {
    //         navigate('/');
    //     }
    // }, [navigate]);

    useEffect(() => {

    console.log('========== ORDER TYPE GUARD ==========');
    console.log('OrderReview orderType:', orderType);
        if (!orderType) {
          navigate('/dashboard');
        }
      }, [orderType, navigate]);
      
    const onUpdateQty = async (cartId, newQty) => {
        await handleUpdateQty(cartId, newQty);
        console.log("orderreview",refresh)
        setRefresh(prev => !prev); 
        console.log("orderreview",refresh)
      };
      
      const onRemoveItem = async (cartId) => {
        await handleRemoveItem(cartId);
        setRefresh(prev => !prev); 
      };

      const {
        selectedItem,
        isModalOpen,
        openEditModal,
        closeModal
      } = useEditCartItem(editOrderId);

    return (
        <MainLayoutWithoutFooter  guardedNavigate={guardedNavigate}>
            <div className="pageContent orederReviewPage">
                <div className="container">
                    <h2 className="lgTitle mb-3">Cart</h2>
                    {isAutoTaggedServer ? (
                        <div className="cardStyle mb-4">
                            <div className="cardBody">
                                <strong>Server:</strong> {localStorage.getItem('active_staff_name') || 'Current staff'}
                            </div>
                        </div>
                    ) : (
                        <Server
                            servers={isOfflineAndroid() ? offlineServers : servers}
                            selectedServerId={selectedServerId}
                            onChange={setSelectedServerId}
                        />
                    )}
                    <h2 className="lgTitle mb-3">Order Details</h2>
                    <div className="row g-3">
                        <OrderDetails
                            cartItems={cartItems}
                            dealsItem={dealsItem}
                            halfAndHalfItems={halfAndHalfItems}
                            handleUpdateQty={onUpdateQty}
                            handleRemoveItem={onRemoveItem}
                            removeID={removeID} 
                            orderType={orderType}
                            selectedTables={selectedTables}
                            onEditCartItem={openEditModal}
                            existingOrderId={existing_order_id}
                            />
                            
                        <OrderReviewSidebar netTotal={netTotal}   
                        orderType={orderType}
                        selectedTables={selectedTables}   
                        existing_order_id={existing_order_id}
                        selected_customer_id={selected_customer_id}
                        selected_table_ids={selected_table_ids}
                        serverId={selectedServerId}
                        servers={servers}
                        editOrderId={editOrderId}
                        initialServiceType={initialServiceType}
                        isPagerOrder={isPagerOrder}
                        />
                    </div>
                </div>
            </div>
            {isModalOpen && (
  <EditModal
    item={selectedItem}
    isOpen={isModalOpen}
    onClose={closeModal}
    onCartChange={() => setRefresh(prev => !prev)}
    editOrderId={editOrderId}
  />
)}

            <GuardedNavigationModal 
            isOpen={showModal} 
            onCancel={cancelNavigation} 
            onConfirm={handleConfirm} 
        />
        </MainLayoutWithoutFooter>
    );
};

export default OrderReview;